import Slide from '@/components/shared/Slide';
import type { RoadmapCompanyConfig, ViewMode } from '@/types/roadmap.types';

interface Props {
  config: RoadmapCompanyConfig;
  mode: ViewMode;
}

export default function ExecutiveSummarySlide({ config, mode }: Props) {
  const { proposal } = config;
  return (
    <Slide mode={mode}>
      <div className="w-full max-w-4xl mx-auto">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">
          Executive Summary
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground mb-10">
          Scope &amp; Methodology
        </h2>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          <div>
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-3">
              Engagement Scope
            </p>
            <p className="text-base text-foreground/80 leading-relaxed mb-6">
              {proposal.engagement_scope}
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-muted-foreground">
                Time horizon:{' '}
                <strong className="text-foreground">{proposal.time_horizon}</strong>
              </span>
            </div>
          </div>

          <div className="space-y-4">
            <div className="rounded-xl border border-border/60 p-5">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 rounded-lg bg-primary/[0.07] flex items-center justify-center">
                  <span className="text-primary font-bold text-sm">1</span>
                </div>
                <h3 className="font-semibold text-foreground">
                  Grant Identification
                </h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed pl-11">
                Non-dilutive funding opportunities matched to your technology
                scope, eligibility profile, and geographic footprint.
              </p>
            </div>
            <div className="rounded-xl border border-border/60 p-5">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 rounded-lg bg-secondary/[0.12] flex items-center justify-center">
                  <span className="text-secondary font-bold text-sm">2</span>
                </div>
                <h3 className="font-semibold text-foreground">
                  Strategic Roadmap
                </h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed pl-11">
                Scored and prioritized program recommendations with timelines,
                risk assessments, and actionable next steps.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
}
